import { v1 as uuidv1 } from 'uuid';

export const SHOW = `OnScreenKeyboard: SHOW→${uuidv1()}`;
export const HIDE = `OnScreenKeyboard: HIDE→${uuidv1()}`;
export const ENABLE = `OnScreenKeyboard: ENABLE→${uuidv1()}`;
export const DISABLE = `OnScreenKeyboard: DISABLE→${uuidv1()}`;

export const CLASS_KEYBOARD = 'onScreenKeyboard--nofocus';
